var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_660",
    "data-name": "Group 660",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.262,
    height: 51.261,
    viewBox: "0 0 51.262 51.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M25.63,0A25.63,25.63,0,1,1,0,25.63,25.63,25.63,0,0,1,25.63,0Z",
    fill: "#0b2a46",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M7.873,2.07a7.313,7.313,0,0,0-2.432.47A5.126,5.126,0,0,0,2.515,5.476a7.362,7.362,0,0,0-.461,2.435C2.007,8.978,2,9.322,2,12.043s.017,3.063.069,4.133a7.339,7.339,0,0,0,.47,2.432,5.123,5.123,0,0,0,2.937,2.927A7.357,7.357,0,0,0,7.912,22c1.067.047,1.411.057,4.133.052s3.064-.017,4.134-.068a7.333,7.333,0,0,0,2.431-.47,5.123,5.123,0,0,0,2.926-2.938A7.338,7.338,0,0,0,22,16.139c.047-1.07.058-1.411.052-4.134s-.017-3.063-.068-4.133a7.328,7.328,0,0,0-.47-2.433,4.927,4.927,0,0,0-1.159-1.774,4.892,4.892,0,0,0-1.778-1.152,7.324,7.324,0,0,0-2.434-.461c-1.067-.046-1.411-.058-4.133-.053s-3.063.017-4.133.069m.117,18.124a5.554,5.554,0,0,1-1.862-.341A3.124,3.124,0,0,1,4.975,19.1a3.083,3.083,0,0,1-.752-1.151,5.549,5.549,0,0,1-.349-1.861c-.049-1.056-.06-1.373-.066-4.05s0-2.993.051-4.05A5.539,5.539,0,0,1,4.2,6.129a3.109,3.109,0,0,1,.748-1.154A3.089,3.089,0,0,1,6.1,4.222a5.543,5.543,0,0,1,1.86-.349c1.057-.05,1.374-.06,4.05-.066s2.994,0,4.052.051a5.53,5.53,0,0,1,1.861.341,3.32,3.32,0,0,1,1.907,1.9,5.516,5.516,0,0,1,.348,1.86c.05,1.057.062,1.374.067,4.05s0,2.994-.051,4.05a5.582,5.582,0,0,1-.341,1.863,3.321,3.321,0,0,1-1.9,1.906,5.561,5.561,0,0,1-1.86.349c-1.057.049-1.374.06-4.051.066s-2.993-.005-4.05-.051M16.164,6.666a1.2,1.2,0,1,0,1.2-1.205h0a1.2,1.2,0,0,0-1.2,1.205M6.878,12.034a5.148,5.148,0,1,0,5.138-5.158,5.147,5.147,0,0,0-5.138,5.158m1.806,0a3.342,3.342,0,1,1,3.348,3.336,3.342,3.342,0,0,1-3.348-3.336h0",
    transform: "translate(13.754 13.755)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.4616f2ff34cf3ae0b7dbc70624648584.svg";
export { ForwardRef as ReactComponent };